import React, { PureComponent, Fragment } from 'react';
import * as d3Scale from 'd3-scale';

import Icon from '~/core/scripts/components/Icon';
import { numberFormat, isNumeric } from '~/core/scripts/utils';
import ProgressBar from '../ProgressBar';

class InnerRanking extends PureComponent {
  render() {
    const { items, greenVoters, empty = false } = this.props;

    return (
      <div className="innerranking">
        {items.filter(d => d.visible).map((d) => {
          const hasData = isNumeric(d.value);
          const showCheck = (d.key !== 'muell_pk' && d.value >= d.avg) || (d.key === 'muell_pk' && d.value < d.avg);

          return (
            <div className="innerranking__item" key={`innerranking__${d.key}`}>
              {!empty && <div className="innerranking__value">{hasData ? <Fragment>{numberFormat(d.value, d.decimals)}&nbsp;{d.unit}</Fragment> : '-'}</div>}
              <div className="innerranking__name">{d.label}</div>
              {(hasData && !empty) && (
                <ProgressBar
                  scale={d3Scale.scaleLinear().domain([d.min, d.max]).range([0, 100])}
                  value={d.value}
                  avg={d.avg}
                />
              )}

              {(hasData && !empty) && (
                <div className={`innerranking__check ${showCheck ? 'checked' : 'nope'}`}>
                  <Icon type={showCheck ? 'check-bold': 'close-bold'} />
                </div>
              )}

              {(!hasData && !empty) && (
                <div className="progress nodata">keine Daten vorhanden</div>
              )}
            </div>
          );
        })}

        <div className="innerranking__item green">
          {!empty && <div className="innerranking__value">{numberFormat(greenVoters, 1)} %</div>}
          <div className="innerranking__name">Grünen-Wähler</div>
          {!empty && (
            <ProgressBar
              scale={d3Scale.scaleLinear().domain([4.7, 38.5]).range([0, 100])}
              value={greenVoters}
              avg={20.5}
            />
          )}
        </div>
      </div>
    );
  }
}

export default InnerRanking;
